import { render, staticRenderFns } from "./InactiveSurveysTab.vue?vue&type=template&id=d6d4e4f0&scoped=true&"
import script from "./InactiveSurveysTab.vue?vue&type=script&lang=js&"
export * from "./InactiveSurveysTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d4e4f0",
  null
  
)

export default component.exports